const config = {
  serverAddress:
    process.env.REACT_APP_ENV === "development"
      ? "http://localhost:8000"
      : "https://api.letscalendar.app",
};

export default config;
